import React, { useEffect, useState } from 'react';
import { initFlowbite } from 'flowbite';
import SelectImage from './SelectImage';
import Setup from './Setup';
import RunProgress from './RunProgress';
import { Shape } from './Types';
import { DEFAULT_MASK_SIZE, DEFAULT_NUMBER_OF_PINS, DEFAULT_PATH_LENGTH } from './AppConst';

type AppStage = 'select' | 'setup' | 'running';

const App: React.FC = () => {
  const [stage, setStage] = useState<AppStage>('select');
  const [selectedImage, setSelectedImage] = useState('');
  const [selectedShape, setSelectedShape] = useState<Shape>('ellipse');
  const [invertImage, setInvertImage] = useState(false);
  const [maskSize, setMaskSize] = useState(DEFAULT_MASK_SIZE);
  const [pathLength, setPathLength] = useState(DEFAULT_PATH_LENGTH);
  const [numberOfPins, setNumberOfPins] = useState(DEFAULT_NUMBER_OF_PINS);

  useEffect(() => {
    initFlowbite();
  }, []);

  useEffect(() => {
    if (typeof window.scrollTo === 'function') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [stage]);

  const handleImageSelected = (imageUrl: string) => {
    setSelectedImage(imageUrl);
    setStage('setup');
  };

  const handleRun = (
    runImage: string,
    runShape: Shape,
    runInvertImage: boolean,
    runMaskSize: number,
    runPathLength: number,
    runNumberOfPins: number,
  ) => {
    setStage('running');
    setSelectedImage(runImage);
    setSelectedShape(runShape);
    setInvertImage(runInvertImage);
    setMaskSize(runMaskSize);
    setPathLength(runPathLength);
    setNumberOfPins(runNumberOfPins);
  };

  const handleBack = () => {
    setStage('select');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {stage === 'select' && <SelectImage onImageSelected={handleImageSelected} />}
      {stage === 'setup' && (
        <Setup selectedImage={selectedImage} onRun={handleRun} onBack={handleBack} />
      )}
      {stage === 'running' && (
        <RunProgress
          imageUrl={selectedImage}
          shape={selectedShape}
          invertImage={invertImage}
          maskSize={maskSize}
          pathLength={pathLength}
          numberOfPins={numberOfPins}
        />
      )}
    </div>
  );
};

export default App;
